'use client';

import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { opsStore } from '@/infrastructure/store/opsStore';

export function useOps() {
  return useStore(
    opsStore,
    useShallow((s) => ({
      result: s.result,
      loading: s.loading,
      failed: s.failed,
      carteira: s.carteira,
      carteiraLoading: s.carteiraLoading,
      carteiraFailed: s.carteiraFailed,
      recalculating: s.recalculating,
      importing: s.importing,
      query: s.query,
      ajustes: s.ajustes,
      ajustesLoading: s.ajustesLoading,
      ajustesFailed: s.ajustesFailed,
      desfazendoId: s.desfazendoId,
      voltandoUid: s.voltandoUid,
      classificandoLote: s.classificandoLote,
      ultimaImportacao: s.ultimaImportacao,
      ultimaImportacaoLoading: s.ultimaImportacaoLoading,
      ultimaImportacaoFailed: s.ultimaImportacaoFailed,
      importacoes: s.importacoes,
      importacoesLoading: s.importacoesLoading,
      importacoesFailed: s.importacoesFailed,
      desfazendoImportacaoId: s.desfazendoImportacaoId,
      load: s.load,
      recalcular: s.recalcular,
      update: s.update,
      marcarLiberacao: s.marcarLiberacao,
      importar: s.importar,
      voltarParaCarteira: s.voltarParaCarteira,
      restaurarOp: s.restaurarOp,
      tirarDaCarteira: s.tirarDaCarteira,
      reclassificarSaida: s.reclassificarSaida,
      reclassificarSaidasEmLote: s.reclassificarSaidasEmLote,
      loadAjustes: s.loadAjustes,
      loadCarteira: s.loadCarteira,
      loadUltimaImportacao: s.loadUltimaImportacao,
      loadImportacoes: s.loadImportacoes,
      previaDoDesfazer: s.previaDoDesfazer,
      desfazerImportacao: s.desfazerImportacao,
      desfazerAjuste: s.desfazerAjuste,
    })),
  );
}
